(function () {
  'use strict';

  /*
    ECLO routines V2 loader.
    Static copy is translated server-side by Shopify. Dynamic commerce copy,
    money formatting and localized duration matching live in the core asset.
    Keeping this loader deliberately small avoids the former EN-wide
    MutationObserver / DOM-rewrite pass and its visual/performance overhead.
  */
  var w = window;
  var d = document;
  var current = d.currentScript;
  var currentSrc = current && current.src ? current.src : '';
  var CORE_PROMISE = '__ecloRoutinesV2CorePromise';

  function coreUrl() {
    if (!currentSrc) return '';
    return currentSrc.replace(/eclo-routines-v2\.js(?=\?|$)/, 'eclo-routines-v2-core.js');
  }

  function loadCore() {
    if (w[CORE_PROMISE]) return w[CORE_PROMISE];
    w[CORE_PROMISE] = new Promise(function (resolve, reject) {
      var src = coreUrl();
      if (!src || src === currentSrc) {
        reject(new Error('ECLO routines core URL could not be resolved.'));
        return;
      }
      var script = d.createElement('script');
      script.src = src;
      script.async = false;
      script.onload = resolve;
      script.onerror = function () { reject(new Error('ECLO routines core failed to load.')); };
      (d.head || d.documentElement).appendChild(script);
    });
    return w[CORE_PROMISE];
  }

  loadCore().catch(function (error) {
    if (w.console && console.error) console.error(error);
  });
}());
